import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const RhapsodyChat = forwardRef<SVGSVGElement, SvgIconProps>(
  function ClientAndPatient(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <rect
          fill="transparent"
          height="18.5"
          rx="9.25"
          stroke="currentColor"
          strokeWidth="1.5"
          width="18.5"
          x="2.75"
          y="2.75"
        />
        <path
          d="M8.29794341,0.000117172537 L3.70205672,0.000117172537 C1.65728229,0.000117172537 0,1.60069402 0,3.57341085 C0,5.15067036 1.05841709,6.48538273 2.52646924,6.96040019 L4.28572304,8.66666667 L5.85960695,7.14752473 L8.29794341,7.14752473 C10.3427178,7.14752473 12,5.54788526 12,3.57282498 C12,1.60057685 10.3427178,0 8.29794341,0 L8.29794341,0.000117172537 Z M3.14291216,4.33280606 C2.68910188,4.33280606 2.32160333,3.97854661 2.32160333,3.54006354 C2.32160333,3.1029514 2.68957532,2.74732103 3.14291216,2.74732103 C3.59672243,2.74732103 3.96422099,3.10296311 3.96422099,3.54006354 C3.96422099,3.97854661 3.59624899,4.33280606 3.14291216,4.33280606 Z M5.99993937,4.33280606 C5.54612909,4.33280606 5.17863054,3.97854661 5.17863054,3.54006354 C5.17863054,3.1029514 5.54612909,2.74732103 5.99993937,2.74732103 C6.4532762,2.74732103 6.82172164,3.10296311 6.82172164,3.54006354 C6.82172164,3.97854661 6.45326407,4.33280606 5.99993937,4.33280606 Z M8.85696658,4.33280606 C8.40315631,4.33280606 8.03518431,3.97854661 8.03518431,3.54006354 C8.03518431,3.1029514 8.40268287,2.74732103 8.85696658,2.74732103 C9.31030342,2.74732103 9.67827587,3.10296311 9.67827587,3.54006354 C9.67875006,3.97854661 9.31077686,4.33280606 8.85696658,4.33280606 Z"
          transform="translate(6, 8)"
        />
      </SvgIcon>
    )
  },
)

export default RhapsodyChat
